export interface INavItem {
    displayStr: string,
    urlStr: string
}

export const navBarArr: INavItem[] = [
    {
        displayStr: "Home",
        urlStr: "/"
    },
    {
        displayStr: "About Us",
        urlStr: "/aboutus"
    },
    {
        displayStr: "Donuts",
        urlStr: "/donuts"
    },
    {
        displayStr: "Login",
        urlStr: "/login"
    },
    {
        displayStr: "Sign Up",
        urlStr: "/signup"
    },
    {
        displayStr: "My Cart",
        urlStr: "/cart"
    }
]
